module.exports = global.config = {
    pageTitles: {
		title:"Diane P Taylor Therapy",
		seperator:" | ",
		learn:"Learn",
		contact:"Contact",
		testimonials:"Testimonials",
		schedule:"Schedule",
		notfound:"Not Found"
	},
    vars: {
		assetURL: "https://assets.d24t4pc400ah3.amplifyapp.com",
		contentURL: "https://www.sjsoftwaresolutions.com/sjsoftware/ds/handlers/KyraContent",
		sjURL: "https://www.sjsoftwaresolutions.com/sjsoftware/home",
		registerURL: "https://www.sjsoftwaresolutions.com/sjsoftware/ds/handlers/KyraRegisterContent",
		loginURL: "https://www.sjsoftwaresolutions.com/sjsoftware/ds/handlers/KyraLoginContent",
		postURL: "https://www.sjsoftwaresolutions.com/sjsoftware/ds/handlers/KyraPostContent",
		communityURL: "https://www.sjsoftwaresolutions.com/sjsoftware/ds/handlers/KyraCommunityContent"
    },
    imgs: {
		banner1: "/images/diane_banner.png",
		banner2: "/images/diane_banner2.png",
		banner3: "/images/knox.jpg",
	},
	docs: {
		intake:"/docs/Intake Packet.pdf"
	},
	content: {
		arrival: "/api/content.json"
	},
	fadein: {
		delay: 500,
		duration: 3000
	},
	auth: {
		email: "https://www.sjsoftwaresolutions.com/sjsoftware/ds/handlers/ClientEmail",
		code: "EIqqRF!6KahJD88UOIWoU!!73824L"
	}
};